// ServicePage.js
import React, { useEffect } from "react";
import ServiceBanner from "../Components/ServiceBanner";
import ServiceAbout from "../Components/ServiceAbout";
import ServiceDoctors from "../Components/ServiceDoctor";
import ServiceMoreService from "../Components/ServiceMoreService";
import AOS from "aos";
import "aos/dist/aos.css";
import "animate.css";
import { ServiceProvider, useService } from "../ServiceContext"; // Import the context

const ServicePageContent = () => {
  const { service } = useService(); // Use the context hook

  if (!service) {
    return <h2 className="text-center text-2xl mt-10">Service Not Found</h2>;
  }

  return (
    <>
      <title>
        {service.metaTitle}
      </title>
      <meta name="description" content={service.metaDescription} />
      <ServiceBanner />
      <ServiceAbout />
      <ServiceDoctors />
      <ServiceMoreService />
    </>
  );
};

const ServicePage = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  return (
    <ServiceProvider>
      <ServicePageContent />
    </ServiceProvider>
  );
};

export default ServicePage;